import { withRouter } from 'react-router-dom';
class Singlechips extends React.Component{
  constructor(props){
    super(props); 
  
  }
render(){
  return (
  <li>{this.props.label.name}<span className="filter-clse" onClick={() => this.props.removeChips({ 'value': this.props.label.value, 'key': this.props.label.selectedKey })} >
        <svg xmlns="http://www.w3.org/2000/svg" width={6} height="5.998" viewBox="0 0 6 5.998">
        <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M15,14.288l2.143-2.143a.5.5,0,1,0-.71-.71l-2.143,2.143-2.143-2.143a.5.5,0,1,0-.71.71l2.143,2.143-2.143,2.143a.5.5,0,0,0,.71.71L14.286,15l2.143,2.143a.5.5,0,0,0,.71-.71Z" transform="translate(-11.285 -11.289)" fill="#2d71fd" opacity="0.7" />
      </svg>
      </span>
      </li>  
  )
  }
}
export default withRouter(Singlechips);